import * as types from "./types";

const mutations = {
    [types.LOADING_LEAVETYPE](state, value) {
        state.loading = value;
    },
    [types.GET_LEAVETYPE_LIST](state, leavetypes) {
        state.leavetypes = leavetypes;
    },
    [types.REMOVE_LEAVETYPE](state, id) {        
        state.leavetypes = state.leavetypes.filter((x) => x.id !== id);        
    },
    [types.ADD_LEAVETYPE](state, leavetype) {        
        state.leavetypes.unshift(leavetype);
    },
    [types.UPDATE_LEAVETYPE](state, leavetype) {        
        const leavetypeIndex = state.leavetypes.findIndex((x) => x.id === leavetype.id);
        state.leavetypes[leavetypeIndex] = leavetype;        
    },
    [types.GET_LEAVETYPEBYID](state, leavetypeId) {
        state.leavetypeId = leavetypeId;
    }
};

export default mutations;